/**
 * Catálogo Design System — Vuetify theme map (Palette v3 "Warm Graphite")
 *
 * Imported by resources/js/app.js:
 *
 *   import { vuetifyThemes } from '../../design-system/tokens/vuetify-theme.js'
 *   ...
 *   vuetify: new Vuetify({
 *     theme: { dark: isDarkTheme, options: { customProperties: true }, themes: vuetifyThemes },
 *     icons: { iconfont: 'mdi' },
 *   })
 *
 * MIRRORS tokens.css — which is the source of truth for color values.
 * Changing a hex here without changing it there splits the two theme
 * mechanisms apart: Vuetify components would follow this map while everything
 * styled in CSS follows the custom properties.
 *
 * `accent` is the offer green, not an orange: it is anchored to the #4CAF50
 * badge in the protected PDF card.
 */
export const vuetifyThemes = {
  light: {
    primary: '#2563EB',
    secondary: '#0D9488',
    accent: '#4CAF50',
    error: '#DC2626',
    info: '#0EA5E9',
    success: '#059669',
    warning: '#F59E0B',
  },
  dark: {
    primary: '#6E9FDE',
    secondary: '#4FA79C',
    accent: '#6FBF73',
    error: '#E2726D',
    info: '#5AA6C9',
    success: '#63A97F',
    warning: '#D9A441',
  },
}

export default vuetifyThemes
